<template>
    <div class="section-bank-transfer">
        <div class="section-bank-transfer__content-header">
            <ButtonCustom
                type="go-back"
                text="Bank Transfer"
                :isGoBackHistory="false"
                @onClickButton="$emit('onClickGoBack')"
            />
            <div
                class="section-bank-transfer__box-btn section-bank-transfer__box-btn-desktop"
                slot="button"
            >
                <div class="section-bank-transfer__process-time">{{ getTranslatedText("processing time might take 5-7 working days") }}</div>
                <button
                    class="t-transform-cap"
                    type="submit"
                    @click="onSubmitForm"
                    :disabled="isLoadingButton"
                >
                    <b-spinner v-if="isLoadingButton" />
                    {{ getTranslatedText("continue to bank") }}
                    {{ getTranslatedText("transfer") }}
                    <img
                        src="@/assets/images/wallet/vector-right.png"
                        alt="vector-right"
                    />
                </button>
            </div>
            <div
                class="section-bank-transfer__transfer-amount section-bank-transfer__transfer-amount__mobile"
            >
                <p
                    class="section-bank-transfer__transfer-amount-text t-transform-cap"
                >
                    {{ getTranslatedText("transfer amount") }}
                </p>
                <div class="section-bank-transfer__transfer-amount-price" :class="{ isRtl: $store.state.isRtl }">
                     <b-form-input
                        v-model="amount"
                        id="input-add-credit"
                        @blur="formatter"
                        @keydown.native="checkDigit"
                    ></b-form-input>
                    <!-- <b-form-input
                        v-model="amount"
                        id="input-amount"
                        @blur="formatter"
                        @keydown.native="checkDigit"
                    ></b-form-input> -->
                    <span>{{ getTranslatedText("OMR") }}</span>
                </div>
            </div>
        </div>
        <div class="section-bank-transfer__content">
            <div class="section-bank-transfer__content-form">
                <div
                    class="section-bank-transfer__transfer-amount section-bank-transfer__transfer-amount__desktop"
                >
                    <p
                        class="section-bank-transfer__transfer-amount-text t-transform-cap"
                    >
                        {{ getTranslatedText("transfer amount") }}
                    </p>
                    <div class="section-bank-transfer__transfer-amount-price">
                        <b-form-input
                            v-model="amount"
                            id="input-add-credit"
                            @blur="formatter"
                            @keydown.native="checkDigit"
                        ></b-form-input>
                        <span>{{ getTranslatedText("OMR") }}</span>
                    </div>
                </div>
                <p
                    class="section-bank-transfer__content-form-title t-fir-transform-cap"
                >
                    {{
                        getTranslatedText(
                            `minimum the withdrawal amount is ${limitAmount} OMR`
                        )
                    }}
                </p>
                <FormCommon
                    :formItem="formItem"
                    :dataForm="dataForm"
                    @update-form-data="updateFormData"
                    @onSubmitForm="onSubmitForm"
                >
                    <div class="section-bank-transfer__box-btn" slot="button">
                        <div class="section-bank-transfer__process-time">{{ getTranslatedText("processing time might take 5-7 working days") }}</div>
                        <button
                            class="t-transform-cap"
                            type="submit"
                            :disabled="isLoadingButton"
                        >
                            <b-spinner v-if="isLoadingButton" />
                            {{ getTranslatedText("continue to bank") }}
                            {{ getTranslatedText("transfer") }}
                            <img
                                src="@/assets/images/wallet/vector-right.png"
                                alt="vector-right"
                            />
                        </button>
                    </div>
                </FormCommon>
            </div>
        </div>
    </div>
</template>
<script>
import { checkDigitCommon, isStrEmpty } from "@/components/common/utils";

import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import languageMixin from "@/mixins/language/language-mixin";
import countriesService from "../../../../services/countries.service";
import BankService from "../../../../services/bank.service";

const VUE_APP_WITH_AMOUNT = process.env.VUE_APP_WITH_AMOUNT;
const VUE_APP_WITH_AMOUNT_MAXIUM = process.env.VUE_APP_WITH_AMOUNT_MAXIUM;

export default {
    mixins: [languageMixin],
    components: { FormCommon, ButtonCustom },
    props: {
        isLoadingButton: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            limitAmount: VUE_APP_WITH_AMOUNT,
            maxiumAmount: VUE_APP_WITH_AMOUNT_MAXIUM,
            amount: VUE_APP_WITH_AMOUNT,
            dataForm: {
                account_name: "",
                bank_name: "",
                branch_code: "",
                account_number: "",
                city: "",
                country: "",
                bank_account_currency: "",
                swift_code: "",
                isAccountNumber: true,
                isIban: true,
            },
            formItem: [
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "beneficiary name",
                    name: "account_name",
                    required: true,
                    label: "beneficiary name",
                    for: "input-name",
                    id: "input-name",
                },
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "city",
                    name: "city",
                    required: true,
                    label: "city",
                    for: "input-city",
                    id: "input-city",
                },
                {
                    type: "select",
                    name: "country",
                    required: true,
                    label: "country",
                    for: "input-country",
                    id: "input-country",
                    idGroup: "input-group-country",
                    options: [],
                },
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "bank name",
                    name: "bank_name",
                    required: true,
                    label: "bank name",
                    for: "input-bank-name",
                    id: "input-bank-name",
                },
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "beneficiary account",
                    name: "account_number",
                    required: true,
                    label: "beneficiary account #",
                    for: "input-account_number",
                    id: "input-account_number",
                    isShow: true,
                },
                {
                    type: "select",
                    name: "bank_account_currency",
                    required: true,
                    label: "bank account currency",
                    for: "input-bank_account_currency",
                    id: "input-bank_account_currency",
                    options: [],
                },
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "iban",
                    name: "branch_code",
                    required: true,
                    label: "iban / clabe #",
                    for: "input-branch_code",
                    id: "input-branch_code",
                },
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "swift code",
                    name: "swift_code",
                    required: true,
                    label: "swift code",
                    for: "input-swift_code",
                    id: "input-swift_code",
                },
            ]
        };
    },
    mounted() {
        // let input = document.getElementById("input-amount");
        // input.addEventListener("input", this.resizeInput);
        // this.resizeInput.call(input);
    },
    created() {
        this.fetchDataCountries();
        this.fetchCurrencies();
    },

    methods: {
        fetchCurrencies() {
            try {
                BankService.getCurrencies().then(res => {
                    this.formItem[5].options = res.currencies.map(({ code, name }) => ({
                        value: code,
                        text: name,
                    }));
                    this.formItem[5].options.unshift({value: '', text: this.getTranslatedText('Select')})
                })

            } catch (error) {
                console.log(error);
            }
        },
        async fetchDataCountries() {
            try {
                const resp = await countriesService.getCountries();

                if (resp.status === 200) {
                    const countries = resp.data.map(({ code, name }) => ({
                        value: code,
                        text: name,
                    }));

                    this.formItem[2].options = countries;
                    this.formItem[2].options.unshift({value: '', text: this.getTranslatedText('Select')})
                };
            } catch (error) {
                console.log(error);
            }
        },
        onSubmitForm() {
            if (parseFloat(this.amount.replace(",", "")) === 0) {
                this.$emit(
                    "showToast",
                    "please enter transfer amount",
                    "error"
                );

                return false;
            }

            if (
                parseFloat(this.amount.replace(",", "")) <
                parseFloat(this.limitAmount)
            ) {
                this.$emit(
                    "showToast",
                    "Minimum withdrawal amount is " + this.limitAmount + "OMR",
                    "error"
                );

                return false;
            }

            if (
                parseFloat(this.amount.replace(",", "")) >
                parseFloat(this.maxiumAmount)
            ) {
                this.$emit(
                    "showToast",
                    "Maximum withdrawal amount is " +
                        this.maxiumAmount +
                        " OMR",
                    "error"
                );

                return false;
            }

            let param = { ...this.dataForm };
            param["amount"] = this.amount;

            this.$emit("onSubmit", param);
        },

        resizeInput() {
            let input = document.getElementById("input-amount");
            input.style.width =
                input.value.replaceAll(".", "").length + 1 + "ch";
        },

        updateFormData(item) {
            let { value, name } = item;
            if (name !== "email" && name !== "phone") {
                this.dataForm[name] = value;
            }
            if(name==='country') {
                BankService.checkRequiredIban(value).then(res=> {
                    const iban = res.data.iban;
                    if(iban==="required") {
                        this.dataForm.isAccountNumber = false;
                        this.dataForm.account_number = "";
                        this.dataForm.isIban = true;
                        this.formItem= [
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "beneficiary name",
                                name: "account_name",
                                required: true,
                                label: "beneficiary name",
                                for: "input-name",
                                id: "input-name",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "city",
                                name: "city",
                                required: true,
                                label: "city",
                                for: "input-city",
                                id: "input-city",
                            },
                            {
                                type: "select",
                                name: "country",
                                required: true,
                                label: "country",
                                for: "input-country",
                                id: "input-country",
                                idGroup: "input-group-country",
                                options: [],
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "bank name",
                                name: "bank_name",
                                required: true,
                                label: "bank name",
                                for: "input-bank-name",
                                id: "input-bank-name",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "beneficiary account",
                                name: "account_number",
                                required: false,
                                label: "beneficiary account #",
                                for: "input-account_number",
                                id: "input-account_number",
                                idFormGroup: "id-bank-account_number",
                                isShow: false,
                            },
                            {
                                type: "select",
                                name: "bank_account_currency",
                                required: true,
                                label: "bank account currency",
                                for: "input-bank_account_currency",
                                id: "input-bank_account_currency",
                                options: [],
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "iban",
                                name: "branch_code",
                                required: true,
                                label: "iban / clabe #",
                                for: "input-branch_code",
                                id: "input-branch_code",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "swift code",
                                name: "swift_code",
                                required: true,
                                label: "swift code",
                                for: "input-swift_code",
                                id: "input-swift_code",
                            },
                        ];
                    }
                    if(iban==='optional') {
                        this.dataForm.isAccountNumber = true;
                        this.dataForm.isIban = false;
                        this.formItem= [
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "beneficiary name",
                                name: "account_name",
                                required: true,
                                label: "beneficiary name",
                                for: "input-name",
                                id: "input-name",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "city",
                                name: "city",
                                required: true,
                                label: "city",
                                for: "input-city",
                                id: "input-city",
                            },
                            {
                                type: "select",
                                name: "country",
                                required: true,
                                label: "country",
                                for: "input-country",
                                id: "input-country",
                                idGroup: "input-group-country",
                                options: [],
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "bank name",
                                name: "bank_name",
                                required: true,
                                label: "bank name",
                                for: "input-bank-name",
                                id: "input-bank-name",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "beneficiary account",
                                name: "account_number",
                                required: true,
                                label: "beneficiary account #",
                                for: "input-account_number",
                                id: "input-account_number",
                                idFormGroup: "id-bank-account_number",
                                isShow: true,
                            },
                            {
                                type: "select",
                                name: "bank_account_currency",
                                required: true,
                                label: "bank account currency",
                                for: "input-bank_account_currency",
                                id: "input-bank_account_currency",
                                options: [],
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "iban",
                                name: "branch_code",
                                required: false,
                                label: "iban / clabe #",
                                for: "input-branch_code",
                                id: "input-branch_code",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "swift code",
                                name: "swift_code",
                                required: true,
                                label: "swift code",
                                for: "input-swift_code",
                                id: "input-swift_code",
                            },
                        ]
                    }
                    if(iban==="not_required") {
                        this.dataForm.isAccountNumber = true;
                        this.dataForm.isIban = false;
                        this.formItem= [
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "beneficiary name",
                                name: "account_name",
                                required: true,
                                label: "beneficiary name",
                                for: "input-name",
                                id: "input-name",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "city",
                                name: "city",
                                required: true,
                                label: "city",
                                for: "input-city",
                                id: "input-city",
                            },
                            {
                                type: "select",
                                name: "country",
                                required: true,
                                label: "country",
                                for: "input-country",
                                id: "input-country",
                                idGroup: "input-group-country",
                                options: [],
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "bank name",
                                name: "bank_name",
                                required: true,
                                label: "bank name",
                                for: "input-bank-name",
                                id: "input-bank-name",
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "beneficiary account",
                                name: "account_number",
                                required: true,
                                label: "beneficiary account #",
                                for: "input-account_number",
                                id: "input-account_number",
                                idFormGroup: "id-bank-account_number",
                                isShow: true,
                            },
                            {
                                type: "select",
                                name: "bank_account_currency",
                                required: true,
                                label: "bank account currency",
                                for: "input-bank_account_currency",
                                id: "input-bank_account_currency",
                                options: [],
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "iban",
                                name: "branch_code",
                                required: false,
                                label: "iban / clabe #",
                                for: "input-branch_code",
                                id: "input-branch_code",
                                isShow: false,
                            },
                            {
                                type: "input",
                                typeInput: "text",
                                placeholder: "swift code",
                                name: "swift_code",
                                required: true,
                                label: "swift code",
                                for: "input-swift_code",
                                id: "input-swift_code",
                            },
                        ];
                    }
                    this.fetchDataCountries();
                    this.fetchCurrencies();
                })
            }
        },

        formatter(event) {
            const { value } = event.target;
            let isContainsLowercase = /^(?=.*[a-z]).*$/;
            this.amount = !isStrEmpty(value) && !isContainsLowercase.test(value) ? parseFloat(value.replace(/,/g, ""))
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00';
            // let input = document.getElementById("input-amount");
            // let length = this.amount.replaceAll(".", "").length;
            // let numberMore = (this.amount.match(/,/g) || []).length;
            // numberMore = numberMore > 0 ? -numberMore + 1 : 0.5;
            // input.style.width = length + numberMore + "ch";
        },

        checkDigit(event) {
            return checkDigitCommon(event);
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/wallet/_wallet.scss" />
